module.exports = __webpack_public_path__ + "img/91b45993e28cd169a21e4a59b664b612.png";